import { Container, Typography, Box, List, ListItem, ListItemText } from "@mui/material";
import { Helmet } from "react-helmet";

export default function FreeAiChatbotFr() {
  const base =
    (typeof window !== "undefined" && window.location && window.location.origin) ||
    "https://talk-mate-backend.web.app";
  const enUrl = `${base}/en/free-ai-chatbot`;
  const frUrl = `${base}/fr/chatbot-ia-gratuit`;

  return (
    <Container sx={{ py: 6 }}>
      <Helmet>
        <title>Chatbot IA gratuit pour site web – Talkmate</title>
        <meta
          name="description"
          content="Créez un agent IA, ajoutez votre contexte, déployez-le via un code d’embed ou un lien partageable."
        />
        <meta property="og:title" content="Chatbot IA gratuit pour site web – Talkmate" />
        <meta
          property="og:description"
          content="Répondez aux visiteurs automatiquement, capturez des leads, et basculez en réponse manuelle si besoin."
        />
        <meta name="robots" content="index, follow" />
        <link rel="alternate" href={enUrl} hrefLang="en" />
        <link rel="alternate" href={frUrl} hrefLang="fr" />
        <link rel="canonical" href={frUrl} />
      </Helmet>

      <Typography variant="h3" fontWeight={800} gutterBottom>
        Chatbot IA gratuit pour votre site
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Talkmate permet de créer un agent IA, d’ajouter votre contexte métier, et de le déployer en quelques minutes via
        un code d’embed ou un lien partageable.
      </Typography>

      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Ce que vous pouvez faire
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Ajouter le contexte de votre site, produits, FAQ pour des réponses précises." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Déployer via widget, lien public ou iframe sans code complexe." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Basculer en mode manuel : l’opérateur répond et le bot se met en pause." />
          </ListItem>
        </List>
      </Box>

      <Box>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Pourquoi Talkmate ?
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Agent IA configuré en minutes, multilingue, avec contexte personnalisable." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Plan gratuit pour tester : créez un agent, partagez-le et voyez les réponses." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Widget et lien partageable prêts à l’emploi pour capturer les conversations." />
          </ListItem>
        </List>
      </Box>
    </Container>
  );
}
